export default class StorageUtil {
    static setItem(key, val, isSession = false) {
        const adapter = isSession ? sessionStorage : localStorage;
        adapter.setItem(key, JSON.stringify(val));
    }

    static getItem(key, isSession = false) {
        const adapter = isSession ? sessionStorage : localStorage;
        const val = adapter.getItem(key);
        try {
            return JSON.parse(val);
        } catch (err) {
            return val;
        }

    }

    static delItem(key, isSession = false) {
        const adapter = isSession ? sessionStorage : localStorage;
        adapter.removeItem(key);
    }
}
// 定制setItemEvent事件，用于页面监听localStorage变化
var orignalSetItem = localStorage.setItem;
localStorage.setItem = function (key, newValue) {
    var setItemEvent = new Event("setItemEvent");
    setItemEvent.key = key;
    setItemEvent.newValue = newValue;
    window.dispatchEvent(setItemEvent);
    orignalSetItem.apply(this, arguments);
};



// WEBPACK FOOTER //
// ./src/utils/storage-util.js